module.exports = __webpack_public_path__ + "img/review-empty-md.63519d2f.svg";